import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Aris360State } from './aris360.reducer';

export const selectAris360DataState = createFeatureSelector<Aris360State>('aris360');

export const selectAris360List = createSelector(
  selectAris360DataState,
  (state: Aris360State) => state.list
);

export const selectAris360Pagination = createSelector(
  selectAris360DataState,
  (state: Aris360State) => ({
      pageNumber: state.pageNumber,
      pageSize: state.pageSize,
      totalPages: state.totalPages,
      totalRecords: state.totalRecords
  })
);

export const selectAris360DataLoading = createSelector(
    selectAris360DataState,
    (state: Aris360State) => state.loading
);

export const selectAris360DataError = createSelector(
    selectAris360DataState,
    (state: Aris360State) => state.error
);

export const selectAris360Detail = createSelector(
  selectAris360DataState,
  (state: any) => state.detail
);

export const selectAris360DetailLoading = createSelector(
  selectAris360DataState,
    (state: any) => state.loading
);

export const selectAris360DetailError = createSelector(
    selectAris360DataState,
    (state: Aris360State) => state.error
);
